module.exports = `${require.publicPath}sby-icon.8448e583.png`;